<div class="provider-section-grid provider-address-grid" [formGroup]="formGroup">
  <div class="provider-section-header">
    <h5 class="section-title">Basic Information</h5>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="basicFirstName" class="field-label">First name</label>
      <mat-form-field class="provider-fields">
        <input
          id="basicFirstName"
          matInput
          disabled
          type="text"
          placeholder="First name"
          class="user-record-field-input"
          [value]="providerData.firstName ?? ''"/>
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="basicMiddleName" class="field-label">Middle name</label>
      <mat-form-field class="provider-fields">
        <input
          id="basicMiddleName"
          matInput
          disabled
          type="text"
          placeholder="Middle name"
          class="user-record-field-input"
          [value]="providerData.middleName ?? ''"/>
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="basicLastName" class="field-label">Last name</label>
      <mat-form-field class="provider-fields">
        <input
          id="basicLastName"
          matInput
          disabled
          type="text"
          placeholder="Last name"
          class="user-record-field-input"
          [value]="providerData.lastName ?? ''"/>
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="basicPid" class="field-label">PID</label>
      <mat-form-field class="provider-fields">
        <input
          id="basicPid"
          matInput
          disabled
          type="text"
          placeholder="PID"
          class="user-record-field-input"
          [value]="providerData.recordNumber ?? ''"/>
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper">
      <label for="businessName" class="field-label">Business Name</label>
      <mat-form-field class="provider-fields">
        <input
          id="businessName"
          matInput
          type="text"
          placeholder="Business name"
          class="user-record-field-input"
          formControlName="businessName"
          [attr.aria-describedby]="formGroup.get('businessName')?.invalid && formGroup.get('businessName')?.touched ? 'businessName-error' : null" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('businessName')" />
    </div>
  </div>
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper user-record-dropdown-wrapper">
      <label for="providerServiceType" class="field-label">Service</label>
      <mat-form-field class="provider-fields-select">
        <mat-select
          id="providerServiceType"
          class="type-dropdown"
          formControlName="type"
          placeholder="Select service">
          <mat-option value="Tutor">Tutoring</mat-option>
          <mat-option value="Therapy">Therapy</mat-option>
          <mat-option value="Transportation">Transportation</mat-option>
        </mat-select>
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('type')" />
    </div>
  </div>
</div>
